module.exports = __webpack_public_path__ + "static/favicon-0bf9fde04b0fca603c54fa7a3d620cb8.ico";